import { initialState, SearchTab, TTabMethods, TTabStore } from "./tab.state";
import { tabReducer } from "./tab.reducer";

// ✅ Reusable store methods
export const createTabActions = (
    set: any,
    get: () => TTabStore
): Pick<TTabStore, TTabMethods> => ({
    dispatch: (action) => set((state: TTabStore) => tabReducer(state, action)),

    getTabKeys: () => {
        return get().tabs.map((item: SearchTab) => item.key) as string[];
    },

    reset: () => set(initialState),
});
